export default __webpack_public_path__ + "static/media/logo-symbol.bf401585.svg";